import { Shimmer } from '@wartek-id/shimmer'

import { range } from '@/utils/array'

export const AreaCardLoader = () => {
  return (
    <div>
      <div className="flex min-h-[350px] flex-col gap-4 rounded border bg-gray-5 p-4 shadow">
        <Shimmer width={`100%`} height={30} />
        <div className="flex flex-col gap-2">
          {range(1, 10).map((item) => (
            <div className="flex justify-between gap-4" key={item}>
              <Shimmer width={`70%`} height={15} />
              <Shimmer width={40} height={15} />
            </div>
          ))}
          <Shimmer width={`100%`} height={40} className="mt-4" />
        </div>
      </div>
    </div>
  )
}
